const setMessage = (text: string, status: string, display: string, scrollTop: boolean = true) => ({
    type: 'SET_MESSAGE',
    text,
    status,
    display,
    scrollTop
})

export default setMessage